import React from "react";
import Link from "next/link";

import Styles from "./ProfileQuestions.styles";
import { ProfileQuestionsProps as Props } from "./ProfileQuestions.types";
import Navbar from "components/global/Navbar/Navbar";
import ProfileHeader from "components/profile/ProfileHeader/ProfileHeader";
import ProfileNavigation from "components/global/ProfileNavigation/ProfileNavigation";
import Footer from "components/global/Footer/Footer";
import GoBack from "components/global/GoBack/GoBack";

import ArrowSVG from "../../../../public/assets/images/arrow-right.svg";

const ProfileQuestions: React.FC<Props> = props => {
  return (
    <Styles className="ProfileQuestions">
      <header className="ProfileQuestions__header">
        <Navbar
          showBrand={false}
          showBottomContent={false}
          title="Contactar con soporte"
          showCart={false}
        />
        <ProfileHeader className="ProfileQuestions__profile-header" />
      </header>
      <main className="ProfileQuestions__main">
        <ProfileNavigation className="ProfileQuestions__navigation" />
        <div className="ProfileQuestions__content">
          <div className="ProfileQuestions__content__header">
            <GoBack className="ProfileQuestions__content__go-back" />
            <h2 className="ProfileQuestions__content__title">
              Preguntas frecuentes
            </h2>
          </div>
          <div className="ProfileSupport__content__body">
            <Link href="/profile/faq/payphone">
              <a className="ProfileQuestions__link">
                ¿Cómo funciona Payphone? <ArrowSVG />
              </a>
            </Link>
            <Link href="/profile/faq/placetopay">
              <a className="ProfileQuestions__link">
                ¿Cómo funciona Placetopay?
                <ArrowSVG />
              </a>
            </Link>
          </div>
        </div>
      </main>
      <footer className="ProfileQuestions__footer">
        <Footer />
      </footer>
    </Styles>
  );
};

ProfileQuestions.defaultProps = {};

export default ProfileQuestions;
